import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage, buildSuccessMessage} from '../../common/util/errorUtils';
import * as MessageActions from '../../common/messageBox/actions/actions';
import {fetchVehiclesModel} from '../../budgetVehicles/actions/vehiclesModel';


export const fetchBudgetsDates = (year = 2019, month = 2) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/budgets?year=${year}&month=${month}`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_BUDGETS_DATES,
        [
          () => {
            dispatch(fetchVehiclesModel());
            return {
              'type': ActionTypes.FETCHED_BUDGETS_DATES,
            };
          },
        ],
        [
          ActionTypes.FETCHED_BUDGETS_DATES_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'GET',
    }),
  );
};

export const deleteBudgetDate = (id) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/budgets/budget/${id}`,
      'authenticated': true,
      'types': [
        ActionTypes.DELETING_BUDGET_DATE,
        [
          () => {
            return {
              'type': ActionTypes.DELETED_BUDGET_DATE,
              'id': id,
            };
          },
          (response) => MessageActions.addMessageBoxInfo(response.message),
        ],
        [ActionTypes.DELETE_BUDGET_DATE_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'method': 'DELETE',
    })
  );
};

export const addItemBudgetDates = (data = [], year, month) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/budgets/budget',
      'authenticated': true,
      'types': [
        ActionTypes.ADDING_BUDGET_DATE,
        [
          () => {
            dispatch(fetchBudgetsDates(year, month));
            return {
              'type': ActionTypes.ADDED_BUDGET_DATE,
              'payload': data,
            };
          },
          (response) => buildSuccessMessage(response, 'Informacion agregada'),
        ],
        [ActionTypes.ADDING_BUDGET_DATE_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'contentType': 'application/json',
      'method': 'POST',
      'data': data,
    })
  );
};
